import { ChatInput } from './ChatInput';
import { Flex, type AvatarProps, Avatar } from '@chakra-ui/react';
import { Fragment, type ReactNode } from 'react';
import { Messages } from './Messages';

export function Chat({
  chatId,
  currentUserDrn,
  InputHeader,
  onMessageReceived,
  composerNotice,
}: {
  chatId: string;
  currentUserDrn: string;
  // InputHeader is a ReactElement that will be rendered above the chat input
  InputHeader?: React.ComponentType<{ chatId: string }>;
  // Called when a message from another user arrives over the subscription.
  onMessageReceived?: () => void;
  // Rendered in place of the chat input when the reader cannot write here.
  composerNotice?: ReactNode;
}) {
  // NOTE: This component must expand to fill the available space of the parent
  //       as such the height is set to 100%.
  //       Don't set it to 100vh or similar, as that's not always the correct
  //       for where this component is used.
  return (
    <Fragment key={chatId}>
      <Flex height="100%" direction="column" justify={'space-between'} flex="1">
        <Messages
          key={`${chatId}::Messages`}
          chatId={chatId}
          currentUserDrn={currentUserDrn}
          onMessageReceived={onMessageReceived}
        />
        {composerNotice ?? (
          <ChatInput
            key={`${chatId}::ChatInput`}
            chatId={chatId}
            currentUserDrn={currentUserDrn}
            InputHeader={InputHeader}
          />
        )}
      </Flex>
    </Fragment>
  );
}

export const UserAvatar = ({
  user,
  ...props
}: {
  user: {
    first_name?: string | null | undefined;
    last_name?: string | null | undefined;
    picture_url?: string | null | undefined;
  };
} & AvatarProps) => {
  return (
    <Avatar
      {...props}
      boxSize={props.size ? undefined : '10'}
      src={user.picture_url ?? undefined}
      name={getUserFullName(user)}
    />
  );
};

export function getUserFullName(user: {
  first_name?: string | null | undefined;
  last_name?: string | null | undefined;
  picture_url?: string | null | undefined;
}): string | undefined {
  return `${user.first_name ?? ''} ${user.last_name ?? ''}`;
}
